<template>
  <div
    ref="container"
    class="container"
    @click="$emit('input', !on)"
    :style="{ 'background-color': on ? '#b0d255' : '#babcbe' }"
  >
    <div class="ball" :style="{ left: getLeft }">
      <img src="../assets/images/kocka.png" alt="" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  background-color: #babcbe;
  width: 4.6rem;
  height: 2.4rem;
  position: relative;
  border-radius: 1.2rem;
  cursor: pointer;

  .ball {
    height: calc(100% - 4px);
    position: absolute;
    top: 2px;
    left: 2px;
    border-radius: calc((2.4rem - 4px) / 2);
    background-color: #f1f0f1;
    transition: left 0.2s ease-in-out;

    img {
      height: 100%;
      max-height: 100%;
      width: auto;
    }
  }

  &.smaller {
    width: 3.6rem;
    height: 1.8rem;
    border-radius: 0.9rem;

    .ball {
      border-radius: calc((1.8rem - 4px) / 2);
    }
  }
}
</style>

<script>
export default {
  props: {
    on: {
      type: Boolean,
      default: false,
    },
    smaller: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getLeft: function () {
      if (!this.on) {
        return "2px";
      } else {
        if (!this.smaller) {
          return "calc(2.2rem + 2px)";
        } else {
          return "calc(1.8rem + 2px)";
        }
      }
    },
  },
};
</script>
